import { render, staticRenderFns } from "./FormEmployeeAllowance.vue?vue&type=template&id=662505d8"
import script from "./FormEmployeeAllowance.vue?vue&type=script&lang=js"
export * from "./FormEmployeeAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports